// Gerado por tools/assets (`pnpm --filter @eldrun/assets models`). Não edite à mão.
// Fonte: tools/assets/src/avatars/; relatório em docs/assets/model-build-report.json.

/** Esqueleto dos avatares (F88, ADR 0018): o Rig_Medium com os clipes do contrato, sem malha (hash do conteúdo no nome). */
export const AVATAR_RIG = "/modelos/avatares/esqueleto.d93c8c52.glb";

/** Um arquivo por personagem (F88): a malha com a skin no mesmo esqueleto, sem clipes. */
export const AVATAR_FILES = {
  "cavaleiro": "/modelos/avatares/cavaleiro.7d2a1b38.glb",
  "patrulheiro": "/modelos/avatares/patrulheiro.6e9eceb4.glb",
  "barbaro": "/modelos/avatares/barbaro.ef3a45da.glb",
  "ladino": "/modelos/avatares/ladino.19040231.glb",
  "mago": "/modelos/avatares/mago.0828b470.glb",
  "ladino-encapuzado": "/modelos/avatares/ladino-encapuzado.c4468c5f.glb",
} as const;

/** Escala do nó `ajuste` (esqueleto → metros), a mesma em todo arquivo: o item na mão compensa com 1/escala. */
export const AVATAR_SCALE = 0.820963;

/** Malha de cada personagem (o id do conteúdo), com os triângulos e a altura parado (m). */
export const AVATAR_MODELS = {
  "cavaleiro": { tris: 1498, height: 2.076 },
  "patrulheiro": { tris: 1494, height: 1.797 },
  "barbaro": { tris: 1499, height: 1.958 },
  "ladino": { tris: 1494, height: 1.772 },
  "mago": { tris: 1499, height: 2.146 },
  "ladino-encapuzado": { tris: 1494, height: 1.713 },
} as const;

/**
 * Clipes do esqueleto: duração (s) e laço; na locomoção, a velocidade (m/s) em que os pés não escorregam
 * com o clipe a 1×; no golpe, o instante (s) do impacto, que o jogo alinha ao do servidor.
 */
export const AVATAR_CLIPS = {
  "parado": { duration: 1.0667, loop: true },
  "andando": { duration: 1.0667, loop: true, speed: 0.607 },
  "correndo": { duration: 0.8, loop: true, speed: 2.715 },
  "pulando": { duration: 0.6, loop: false },
  "no-ar": { duration: 1.0667, loop: true },
  "aterrissando": { duration: 0.6667, loop: false },
  "agachado": { duration: 0.6585, loop: true, speed: 1.996 },
  "agachado-parado": { duration: 1.0667, loop: true },
  "nadando": { duration: 1.6667, loop: true },
  "golpe": { duration: 1.9167, loop: false, impact: 0.4951 },
  "arco": { duration: 1.25, loop: false },
  "comendo": { duration: 1.6, loop: false },
  "dano": { duration: 0.6667, loop: false },
  "morte": { duration: 0.8, loop: false },
  "revivendo": { duration: 1.2667, loop: false },
} as const;
